import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "breadcrumb" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_8 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_9 = {
  key: 2,
  class: "row"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "row align-items-center" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "card-body border-bottom bg-light" }
const _hoisted_19 = { class: "row g-3" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "col-md-3" }
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "input-group input-group-sm" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "row g-3 mt-2" }
const _hoisted_27 = { class: "col-md-3" }
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = { class: "col-md-3 d-flex align-items-end" }
const _hoisted_31 = { class: "w-100" }
const _hoisted_32 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_33 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_34 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_35 = {
  key: 1,
  class: "badge bg-primary"
}
const _hoisted_36 = {
  key: 2,
  class: "badge bg-primary"
}
const _hoisted_37 = {
  key: 3,
  class: "badge bg-info"
}
const _hoisted_38 = {
  key: 4,
  class: "badge bg-info"
}
const _hoisted_39 = {
  key: 5,
  class: "badge bg-info"
}
const _hoisted_40 = {
  key: 6,
  class: "badge bg-secondary"
}
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_43 = { class: "table table-hover" }
const _hoisted_44 = ["onClick", "title"]
const _hoisted_45 = { class: "fw-medium" }
const _hoisted_46 = {
  key: 0,
  class: "small"
}
const _hoisted_47 = { class: "fw-medium" }
const _hoisted_48 = { class: "text-muted" }
const _hoisted_49 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_50 = { class: "small" }
const _hoisted_51 = {
  key: 0,
  class: "small"
}
const _hoisted_52 = { class: "fw-medium" }
const _hoisted_53 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_54 = {
  key: 0,
  class: "small"
}
const _hoisted_55 = { class: "text-muted" }
const _hoisted_56 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_57 = {
  key: 0,
  class: "small"
}
const _hoisted_58 = ["title"]
const _hoisted_59 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_60 = {
  key: 0,
  class: "small"
}
const _hoisted_61 = ["title", "onClick"]
const _hoisted_62 = {
  key: 0,
  class: "fa fa-expand-alt ms-1 text-primary",
  title: "Click to expand"
}
const _hoisted_63 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_64 = {
  key: 0,
  class: "small"
}
const _hoisted_65 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_66 = { class: "small" }
const _hoisted_67 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_68 = {
  key: 2,
  "aria-label": "KYT logs pagination",
  class: "mt-4"
}
const _hoisted_69 = { class: "pagination justify-content-center" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["disabled"]
const _hoisted_73 = {
  class: "modal fade",
  id: "fullSolutionModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_74 = { class: "modal-dialog modal-lg" }
const _hoisted_75 = { class: "modal-content" }
const _hoisted_76 = { class: "modal-body" }
const _hoisted_77 = { class: "solution-container" }
const _hoisted_78 = { class: "solution-full-text" }

import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { Modal } from 'bootstrap';
import kytChainService from '@/services/kytChainService';
import type { MainKytItem, MainKytsResponse } from '@/types/kyt-chain';

// Router

export default /*@__PURE__*/_defineComponent({
  __name: 'logs-list',
  setup(__props) {

const router = useRouter();

// Reactive state
const loading = ref(false);
const error = ref('');
const mainKytsData = ref<MainKytsResponse | null>(null);
const currentPage = ref(1);
const pageSize = ref(10);
const showFilters = ref(true);
const fullSolutionText = ref('');

// Filters state
const filters = ref({
    siteName: '',
    empName: '',
    status: '',
    nfdFrom: '',
    nfdTo: '',
    dateFrom: '',
    sortBy: '',
    sortOrder: 'desc' as 'asc' | 'desc'
});

// Search debounce timer
let searchTimeout: NodeJS.Timeout | null = null;

// Computed properties
const mainKyts = computed(() => mainKytsData.value?.mainKyts || []);

const hasActiveFilters = computed(() => {
    return filters.value.siteName || 
           filters.value.empName || 
           filters.value.status || 
           filters.value.nfdFrom || 
           filters.value.nfdTo || 
           filters.value.dateFrom || 
           filters.value.sortBy;
});

// Methods
const fetchMainKyts = async (page: number = 1) => {
    loading.value = true;
    error.value = '';
    
    try {
        const queryFilters: any = {
            page,
            limit: pageSize.value
        };
        
        // Add active filters to query
        if (filters.value.siteName) queryFilters.siteName = filters.value.siteName;
        if (filters.value.empName) queryFilters.empName = filters.value.empName;
        if (filters.value.status) queryFilters.status = filters.value.status;
        if (filters.value.nfdFrom) queryFilters.nfdFrom = filters.value.nfdFrom;
        if (filters.value.nfdTo) queryFilters.nfdTo = filters.value.nfdTo;
        if (filters.value.dateFrom) queryFilters.dateFrom = filters.value.dateFrom;
        if (filters.value.sortBy) {
            queryFilters.sortBy = filters.value.sortBy;
            queryFilters.sortOrder = filters.value.sortOrder;
        }
        
        const response = await kytChainService.getMainKyts(queryFilters);
        
        if (response.success) {
            mainKytsData.value = response.data;
            currentPage.value = page;
        } else {
            throw new Error(response.message || 'Failed to fetch KYT logs');
        }
    } catch (err: any) {
        error.value = err.message || 'An error occurred while fetching KYT logs';
        console.error('Error fetching main KYTs:', err);
    } finally {
        loading.value = false;
    }
};

const handleMainLogClick = (parentMainLogNo: string) => {
    // Navigate to the KYTs by log page
    router.push(`/kyt-chain/logs/${parentMainLogNo}/kyts`);
};

const formatDate = (dateString: string): string => {
    if (!dateString) return 'N/A';
    
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (err) {
        return 'Invalid Date';
    }
};

const truncateSolution = (solution: string): string => {
    if (!solution) return 'No solution';
    
    // Split solution into lines and take first 2-3 lines
    const lines = solution.split('\n').filter(line => line.trim() !== '');
    const maxLines = 3;
    const maxCharsPerLine = 60;
    
    let result = '';
    let lineCount = 0;
    
    for (const line of lines) {
        if (lineCount >= maxLines) break;
        
        if (line.length <= maxCharsPerLine) {
            result += (result ? '\n' : '') + line;
        } else {
            // Truncate long lines
            result += (result ? '\n' : '') + line.substring(0, maxCharsPerLine) + '...';
        }
        lineCount++;
    }
    
    // If there are more lines, add indication
    if (lines.length > maxLines) {
        result += '\n...';
    }
    
    return result;
};

const truncateProblem = (problem: string): string => {
    if (!problem) return 'No problem';
    
    // Split problem into lines and take first 2-3 lines
    const lines = problem.split('\n').filter(line => line.trim() !== '');
    const maxLines = 3;
    const maxCharsPerLine = 60;
    
    let result = '';
    let lineCount = 0;
    
    for (const line of lines) {
        if (lineCount >= maxLines) break;
        
        if (line.length <= maxCharsPerLine) {
            result += (result ? '\n' : '') + line;
        } else {
            // Truncate long lines
            result += (result ? '\n' : '') + line.substring(0, maxCharsPerLine) + '...';
        }
        lineCount++;
    }
    
    // If there are more lines, add indication
    if (lines.length > maxLines) {
        result += '\n...';
    }
    
    return result;
};

const isSolutionTruncated = (solution: string): boolean => {
    if (!solution) return false;
    
    const lines = solution.split('\n').filter(line => line.trim() !== '');
    const maxLines = 3;
    const maxCharsPerLine = 60;
    
    // Check if we have more than max lines
    if (lines.length > maxLines) return true;
    
    // Check if any line exceeds max characters
    for (const line of lines) {
        if (line.length > maxCharsPerLine) return true;
    }
    
    return false;
};

const showFullSolution = (solution: string) => {
    if (!solution) return;
    
    fullSolutionText.value = solution;
    
    const modalElement = document.getElementById('fullSolutionModal');
    if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
    }
};

const copySolutionToClipboard = async () => {
    try {
        await navigator.clipboard.writeText(fullSolutionText.value);
        // You could add a toast notification here
        alert('Solution copied to clipboard!');
    } catch (err) {
        console.error('Failed to copy to clipboard:', err);
        alert('Failed to copy to clipboard. Please copy manually.');
    }
};

const changePage = (page: number) => {
    if (page >= 1 && mainKytsData.value?.pagination && page <= mainKytsData.value.pagination.totalPages) {
        fetchMainKyts(page);
    }
};

const getPageNumbers = (): number[] => {
    if (!mainKytsData.value?.pagination) return [];
    
    const totalPages = mainKytsData.value.pagination.totalPages;
    const current = currentPage.value;
    const pages: number[] = [];
    
    // Show up to 5 page numbers centered around current page
    const maxVisible = 5;
    let start = Math.max(1, current - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    
    // Adjust start if we're near the end
    if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
    }
    
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }
    
    return pages;
};

// Filter methods
const applyFilters = () => {
    currentPage.value = 1; // Reset to first page when applying filters
    fetchMainKyts(1);
};

const debouncedSearch = () => {
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    
    searchTimeout = setTimeout(() => {
        applyFilters();
    }, 500); // 500ms delay for search
};

const clearFilters = () => {
    filters.value = {
        siteName: '',
        empName: '',
        status: '',
        nfdFrom: '',
        nfdTo: '',
        dateFrom: '',
        sortBy: '',
        sortOrder: 'desc'
    };
    applyFilters();
};

const clearFilter = (filterKey: string) => {
    if (filterKey === 'sortBy') {
        filters.value.sortBy = '';
        filters.value.sortOrder = 'desc';
    } else {
        (filters.value as any)[filterKey] = '';
    }
    applyFilters();
};

const toggleSortOrder = () => {
    filters.value.sortOrder = filters.value.sortOrder === 'asc' ? 'desc' : 'asc';
    if (filters.value.sortBy) {
        applyFilters();
    }
};

const toggleFilters = () => {
    showFilters.value = !showFilters.value;
};

// Lifecycle hooks
onMounted(() => {
    fetchMainKyts();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-6" }, [
          _createElementVNode("h3", null, "KYT Logs")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ol", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createTextVNode("Home", -1)
                ]))]),
                _: 1
              })
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("li", { class: "breadcrumb-item active" }, "KYT Logs", -1))
          ])
        ])
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[21] || (_cache[21] = [
          _createElementVNode("div", {
            class: "spinner-border",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(error.value) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-outline-danger ms-2",
            onClick: _cache[0] || (_cache[0] = () => fetchMainKyts())
          }, [...(_cache[22] || (_cache[22] = [
            _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
            _createTextVNode(" Retry ", -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    (!loading.value && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[24] || (_cache[24] = _createElementVNode("h5", { class: "mb-0" }, "Main KYT Logs", -1)),
                    _createElementVNode("small", _hoisted_15, " Total: " + _toDisplayString(mainKytsData.value?.summary?.totalMainKyts || 0) + " records ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary btn-sm",
                      onClick: _cache[1] || (_cache[1] = () => fetchMainKyts()),
                      disabled: loading.value
                    }, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                      _createTextVNode(" Refresh ", -1)
                    ]))], 8, _hoisted_17)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[26] || (_cache[26] = _createElementVNode("label", {
                      for: "siteName",
                      class: "form-label small fw-medium"
                    }, "Site Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "siteName",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.value.siteName) = $event)),
                      placeholder: "Search by site name...",
                      onInput: debouncedSearch
                    }, null, 544), [
                      [_vModelText, filters.value.siteName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[27] || (_cache[27] = _createElementVNode("label", {
                      for: "empName",
                      class: "form-label small fw-medium"
                    }, "Employee Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      id: "empName",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.empName) = $event)),
                      placeholder: "Search by employee name...",
                      onInput: debouncedSearch
                    }, null, 544), [
                      [_vModelText, filters.value.empName]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", {
                      for: "status",
                      class: "form-label small fw-medium"
                    }, "Status", -1)),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm",
                      id: "status",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.status) = $event)),
                      onChange: applyFilters
                    }, [...(_cache[28] || (_cache[28] = [
                      _createStaticVNode("<option value=\"\" data-v-200d7b20>All Status</option><option value=\"open\" data-v-200d7b20>Open</option><option value=\"approved\" data-v-200d7b20>Approved</option><option value=\"completed\" data-v-200d7b20>Completed</option><option value=\"pending\" data-v-200d7b20>Pending</option><option value=\"in-progress\" data-v-200d7b20>In Progress</option><option value=\"rejected\" data-v-200d7b20>Rejected</option><option value=\"cancelled\" data-v-200d7b20>Cancelled</option><option value=\"closed\" data-v-200d7b20>Closed</option>", 9)
                    ]))], 544), [
                      [_vModelSelect, filters.value.status]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _cache[31] || (_cache[31] = _createElementVNode("label", {
                      for: "sortBy",
                      class: "form-label small fw-medium"
                    }, "Sort By", -1)),
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("select", {
                        class: "form-select",
                        id: "sortBy",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.sortBy) = $event)),
                        onChange: applyFilters
                      }, [...(_cache[30] || (_cache[30] = [
                        _createStaticVNode("<option value=\"\" data-v-200d7b20>Default</option><option value=\"siteName\" data-v-200d7b20>Site Name</option><option value=\"nfd\" data-v-200d7b20>NFD Date</option><option value=\"createdAt\" data-v-200d7b20>Created Date</option><option value=\"status\" data-v-200d7b20>Status</option>", 5)
                      ]))], 544), [
                        [_vModelSelect, filters.value.sortBy]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        type: "button",
                        onClick: toggleSortOrder,
                        title: filters.value.sortOrder === 'asc' ? 'Sort Ascending' : 'Sort Descending'
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa", filters.value.sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'])
                        }, null, 2)
                      ], 8, _hoisted_25)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _cache[32] || (_cache[32] = _createElementVNode("label", {
                      for: "nfdFrom",
                      class: "form-label small fw-medium"
                    }, "NFD From", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      id: "nfdFrom",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.nfdFrom) = $event)),
                      onChange: applyFilters
                    }, null, 544), [
                      [_vModelText, filters.value.nfdFrom]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", {
                      for: "nfdTo",
                      class: "form-label small fw-medium"
                    }, "NFD To", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      id: "nfdTo",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.nfdTo) = $event)),
                      onChange: applyFilters
                    }, null, 544), [
                      [_vModelText, filters.value.nfdTo]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[34] || (_cache[34] = _createElementVNode("label", {
                      for: "dateFrom",
                      class: "form-label small fw-medium"
                    }, "Created From", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      class: "form-control form-control-sm",
                      id: "dateFrom",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.dateFrom) = $event)),
                      onChange: applyFilters
                    }, null, 544), [
                      [_vModelText, filters.value.dateFrom]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary btn-sm me-2",
                        onClick: clearFilters
                      }, [...(_cache[35] || (_cache[35] = [
                        _createElementVNode("i", { class: "fa fa-times me-1" }, null, -1),
                        _createTextVNode(" Clear ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-info btn-sm",
                        onClick: toggleFilters
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa", showFilters.value ? 'fa-eye-slash' : 'fa-eye'])
                        }, null, 2),
                        _createTextVNode(" " + _toDisplayString(showFilters.value ? 'Hide' : 'Show'), 1)
                      ])
                    ])
                  ])
                ]),
                (hasActiveFilters.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _cache[36] || (_cache[36] = _createElementVNode("span", { class: "small text-muted me-2" }, "Active filters:", -1)),
                        (filters.value.siteName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _createTextVNode(" Site: " + _toDisplayString(filters.value.siteName) + " ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (clearFilter('siteName')))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (filters.value.empName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                              _createTextVNode(" Employee: " + _toDisplayString(filters.value.empName) + " ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (clearFilter('empName')))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (filters.value.status)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                              _createTextVNode(" Status: " + _toDisplayString(filters.value.status) + " ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (clearFilter('status')))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (filters.value.nfdFrom)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _createTextVNode(" NFD From: " + _toDisplayString(filters.value.nfdFrom) + " ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[12] || (_cache[12] = ($event: any) => (clearFilter('nfdFrom')))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (filters.value.nfdTo)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                              _createTextVNode(" NFD To: " + _toDisplayString(filters.value.nfdTo) + " ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (clearFilter('nfdTo')))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (filters.value.dateFrom)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                              _createTextVNode(" Created From: " + _toDisplayString(filters.value.dateFrom) + " ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (clearFilter('dateFrom')))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (filters.value.sortBy)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                              _createTextVNode(" Sort: " + _toDisplayString(filters.value.sortBy) + " (" + _toDisplayString(filters.value.sortOrder) + ") ", 1),
                              _createElementVNode("button", {
                                class: "btn-close btn-close-white ms-1",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (clearFilter('sortBy')))
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, showFilters.value]
              ]),
              _createElementVNode("div", _hoisted_41, [
                (mainKyts.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _createElementVNode("table", _hoisted_43, [
                        _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { scope: "col" }, "Main Log No"),
                            _createElementVNode("th", { scope: "col" }, "Site Name"),
                            _createElementVNode("th", { scope: "col" }, "Employee"),
                            _createElementVNode("th", { scope: "col" }, "Status"),
                            _createElementVNode("th", { scope: "col" }, "Related KYTs"),
                            _createElementVNode("th", { scope: "col" }, "Category"),
                            _createElementVNode("th", { scope: "col" }, "Sub Category"),
                            _createElementVNode("th", { scope: "col" }, "Problem"),
                            _createElementVNode("th", { scope: "col" }, "Solution"),
                            _createElementVNode("th", { scope: "col" }, "Previous NFD"),
                            _createElementVNode("th", { scope: "col" }, "Latest NFD")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainKyts.value, (kyt) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: kyt._id
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-link p-0 text-primary fw-bold",
                                  onClick: ($event: any) => (handleMainLogClick(kyt.parentMainLogNo)),
                                  title: `Click to view details for ${kyt.parentMainLogNo}`
                                }, _toDisplayString(kyt.parentMainLogNo), 9, _hoisted_44)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_45, _toDisplayString(kyt.siteName), 1)
                              ]),
                              _createElementVNode("td", null, [
                                (kyt.latestKytEmployee)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, _toDisplayString(kyt.latestKytEmployee.employeeName), 1),
                                      _createElementVNode("div", _hoisted_48, _toDisplayString(kyt.latestKytEmployee.employeeCode), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_49, "No employee"))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", {
                                                    'bg-success': kyt.status === 'approved' || kyt.status === 'completed',
                                                    'bg-warning text-dark': kyt.status === 'pending' || kyt.status === 'in-progress',
                                                    'bg-danger': kyt.status === 'rejected' || kyt.status === 'cancelled',
                                                    'bg-info text-dark': kyt.status === 'open',
                                                    'bg-secondary': kyt.status === 'closed' || kyt.status === 'draft',
                                                    'bg-primary': kyt.status === 'active',
                                                    'bg-dark': !['approved', 'completed', 'pending', 'in-progress', 'rejected', 'cancelled', 'open', 'closed', 'draft', 'active'].includes(kyt.status)
                                                }])
                                }, _toDisplayString(kyt.status.charAt(0).toUpperCase() + kyt.status.slice(1)), 3)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("div", null, [
                                    _cache[37] || (_cache[37] = _createElementVNode("strong", null, "Total:", -1)),
                                    _createTextVNode(" " + _toDisplayString(kyt.totalRelatedKyts), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _cache[38] || (_cache[38] = _createElementVNode("strong", null, "Children:", -1)),
                                    _createTextVNode(" " + _toDisplayString(kyt.childKytsCount), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                (kyt.latestKytData?.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, _toDisplayString(kyt.latestKytData[0].category), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_53, "No data"))
                              ]),
                              _createElementVNode("td", null, [
                                (kyt.latestKytData?.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                      _createElementVNode("div", _hoisted_55, _toDisplayString(kyt.latestKytData[0].subCategory), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_56, "No data"))
                              ]),
                              _createElementVNode("td", null, [
                                (kyt.latestKytData?.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      _createElementVNode("div", {
                                        class: "problem-text text-muted",
                                        title: kyt.latestKytData[0].problem
                                      }, _toDisplayString(truncateProblem(kyt.latestKytData[0].problem)), 9, _hoisted_58)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_59, "No problem"))
                              ]),
                              _createElementVNode("td", null, [
                                (kyt.latestKytData?.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                      _createElementVNode("div", {
                                        class: "solution-text text-muted clickable",
                                        title: kyt.latestKytData[0].solution,
                                        onClick: ($event: any) => (showFullSolution(kyt.latestKytData[0].solution))
                                      }, [
                                        _createTextVNode(_toDisplayString(truncateSolution(kyt.latestKytData[0].solution)) + " ", 1),
                                        (isSolutionTruncated(kyt.latestKytData[0].solution))
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_62))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_61)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_63, "No solution"))
                              ]),
                              _createElementVNode("td", null, [
                                (kyt.previousKytNFD)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(formatDate(kyt.previousKytNFD)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_65, "N/A"))
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_66, _toDisplayString(formatDate(kyt.latestKytNFD)), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, [...(_cache[40] || (_cache[40] = [
                      _createElementVNode("i", { class: "fa fa-inbox fa-3x text-muted mb-3" }, null, -1),
                      _createElementVNode("h5", { class: "text-muted" }, "No KYT logs found", -1),
                      _createElementVNode("p", { class: "text-muted" }, "There are no KYT logs available at the moment.", -1)
                    ]))])),
                (mainKytsData.value?.pagination && mainKytsData.value.pagination.totalPages > 1)
                  ? (_openBlock(), _createElementBlock("nav", _hoisted_68, [
                      _createElementVNode("ul", _hoisted_69, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: !mainKytsData.value.pagination.hasPrev }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (changePage(currentPage.value - 1))),
                            disabled: !mainKytsData.value.pagination.hasPrev
                          }, " Previous ", 8, _hoisted_70)
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getPageNumbers(), (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            class: _normalizeClass(["page-item", { active: page === currentPage.value }])
                          }, [
                            _createElementVNode("button", {
                              class: "page-link",
                              onClick: ($event: any) => (changePage(page))
                            }, _toDisplayString(page), 9, _hoisted_71)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: !mainKytsData.value.pagination.hasNext }])
                        }, [
                          _createElementVNode("button", {
                            class: "page-link",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (changePage(currentPage.value + 1))),
                            disabled: !mainKytsData.value.pagination.hasNext
                          }, " Next ", 8, _hoisted_72)
                        ], 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _cache[43] || (_cache[43] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "fa fa-lightbulb me-2 text-warning" }),
              _createTextVNode(" Complete Solution ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, [
              _createElementVNode("pre", _hoisted_78, _toDisplayString(fullSolutionText.value), 1)
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _cache[42] || (_cache[42] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, [
              _createElementVNode("i", { class: "fa fa-times me-1" }),
              _createTextVNode(" Close ")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: copySolutionToClipboard
            }, [...(_cache[41] || (_cache[41] = [
              _createElementVNode("i", { class: "fa fa-copy me-1" }, null, -1),
              _createTextVNode(" Copy to Clipboard ", -1)
            ]))])
          ])
        ])
      ])
    ])
  ]))
}
}

})